(function () {

seedWebApp.controller('ShippingDocsCtrl', ShippingDocsCtrl);
    function ShippingDocsCtrl($scope, $routeParams, $rootScope, ToastService, PubService, UtilsService, DocService) {
        var ctrl = this;

        console.log('ShippingDocsCtrl ' + $scope.id);
        $rootScope.printLayout = true;
        $scope.id = $routeParams.id;
        $scope.errMsg = null;
        $scope.loading = true;
        PubService.getEmailDocs($scope.id).then(
            function (resp) {
                $scope.loading = false;
                $scope.email = resp.data;                
            },
            function (error) {
                $scope.loading = false;
                $scope.error = error;
                $scope.errMsg = UtilsService.getErrorMessage(error);
            }
        );

        $scope.downloadDocs = function (files) {
            console.log('download docs');
            for (var i in files) {
                var file = files[i];
                //console.log('download ' + file.Name);
                DocService.showFile(ctrl, file.Name, file.AbsolutePath, true);
            }
        };

    }
})();